import React, { useMemo, useState } from 'react';
import { Button, Label, FormGroup, Input, Row, Col } from 'reactstrap';
import PickupCustomerAutoComplete from './PickupCustomerAutoComplete';
//! Google Map AutoComplete
import GoogleMapAutoComplete, { isCoordinateFallbackLabel } from '../../../Helpers/GoogleMapAutoComplete';
import LocationMapPickerModal from '../../../Helpers/LocationMapPickerModal';
import '../../../Helpers/googleMapAutoComplete.css';
import '../../../../assets/react-mapbox-autocomplete/index.css';

const PickupInfoRouted = ({
  isPickupStore,
  setIsPickupStore,
  errors,
  storeFirstName,
  pickFirstname,
  setPickFirstname,
  pickupCustomerSuggestions,
  setPickupCustomerSuggestions,
  storeId,
  setPickLastname,
  setPickPhone,
  pickFullAddress,
  setPickFullAddress,
  setPickupInstruction,
  isPickupAutoFilled,
  setIsPickupAutoFilled,
  setPickAddress1,
  setPickAddress2,
  setPickCity,
  setPickState,
  setPickZip,
  setPickCountry,
  setPickLat,
  setPickLng,
  setPickBusinessName,
  storeLastName,
  pickLastname,
  storePhone,
  pickPhone,
  storeName,
  pickBusinessName,
  storeAddress,
  handlePickupSelect,
  pickLat,
  pickLng,
  isPickupPinnedLocation,
  setIsPickupPinnedLocation,
  vendorLat,
  vendorLong,
  pickupInstruction,
  setIsWaypointStore
}) => {
  const [isPinModalOpen, setIsPinModalOpen] = useState(false);
  const currentLocation = useMemo(() => {
    if (typeof pickLat !== 'number' || typeof pickLng !== 'number') {
      return null;
    }

    return { lat: pickLat, lng: pickLng, formattedAddress: pickFullAddress || '' };
  }, [pickFullAddress, pickLat, pickLng]);

  return (
    <>
      <Row style={{ paddingTop: 0 }}>
        <FormGroup style={{ padding: 15 }} check className="form-check-radio" id="store-address">
          <Label check>
            <Input
              required
              type="radio"
              checked={isPickupStore}
              value="mp"
              name="store-address-radios2"
              id="my-store-address"
              onClick={() => {
                setIsPickupStore(true);
                setIsWaypointStore(false);
              }}
            />
            <span id="radio" className="form-check-sign" /> Store Address
          </Label>
        </FormGroup>
        <FormGroup style={{ padding: 15 }} check className="form-check-radio" id="shipment-weight">
          <Label check>
            <Input
              required
              type="radio"
              checked={!isPickupStore}
              name="store-address-radios2"
              value="dp"
              id="different-address"
              onClick={() => {
                setIsPickupStore(false);
              }}
            />
            <span id="radio" className="form-check-sign" /> Different Address
          </Label>
        </FormGroup>
      </Row>
      <Row form={true}>
        <Col style={{ textAlign: 'left' }}>
          <Label for="storeFirstName">First Name</Label>
          <FormGroup className={errors.pickupFirstname ? 'has-danger' : 'thisIsAPlaceholderClass'}>
            <PickupCustomerAutoComplete
              isPickupStore={isPickupStore}
              storeFirstName={storeFirstName}
              pickFirstname={pickFirstname}
              setPickFirstname={setPickFirstname}
              pickupCustomerSuggestions={pickupCustomerSuggestions}
              setPickupCustomerSuggestions={setPickupCustomerSuggestions}
              storeId={storeId}
              setPickLastname={setPickLastname}
              setPickPhone={setPickPhone}
              pickFullAddress={pickFullAddress}
              setPickFullAddress={setPickFullAddress}
              setPickupInstruction={setPickupInstruction}
              isPickupAutoFilled={isPickupAutoFilled}
              setIsPickupAutoFilled={setIsPickupAutoFilled}
              setPickAddress1={setPickAddress1}
              setPickAddress2={setPickAddress2}
              setPickCity={setPickCity}
              setPickState={setPickState}
              setPickZip={setPickZip}
              setPickCountry={setPickCountry}
              setPickLat={setPickLat}
              setPickLng={setPickLng}
              setPickBusinessName={setPickBusinessName}
            />
            <div hidden={!errors.pickupFirstname}>
              <p style={{ color: 'red', marginTop: '4px' }}>This is a required field</p>
            </div>
          </FormGroup>
        </Col>
        <Col style={{ textAlign: 'left' }}>
          <Label for="storeLastName">Last Name</Label>
          <FormGroup className={errors.pickupLastname ? 'has-danger' : 'thisIsAPlaceholderClass'}>
            <Input
              required
              readOnly={isPickupStore}
              type="text"
              name="storeLastName"
              id="store-last-name"
              placeholder="Doe"
              onChange={e => (isPickupStore ? null : setPickLastname(e.target.value))}
              value={isPickupStore ? storeLastName : pickLastname}
            />
            <div hidden={!errors.pickupLastname}>
              <p style={{ color: 'red', marginTop: '4px' }}>This is a required field</p>
            </div>
          </FormGroup>
        </Col>
        <Col style={{ textAlign: 'left' }}>
          <Label for="storePhone">Phone Number</Label>
          <FormGroup className={errors.pickupPhone ? 'has-danger' : 'thisIsAPlaceholderClass'}>
            <Input
              readOnly={isPickupStore}
              required
              type="text"
              name="storePhone"
              id="store-phone"
              placeholder="555-555-5555"
              onChange={e => (isPickupStore ? null : setPickPhone(e.target.value))}
              value={isPickupStore ? storePhone : pickPhone}
            />
            <div hidden={!errors.pickupPhone}>
              <p style={{ color: 'red', marginTop: '4px' }}>Please enter a valid phone number (10-13 digits)</p>
            </div>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label for="order-pickup">Business Name (optional)</Label>
            <Input
              readOnly={isPickupStore}
              type="text"
              name="pickBusinessName"
              id="pick-business-name"
              placeholder="Store Name"
              onChange={e => (isPickupStore ? null : setPickBusinessName(e.target.value))}
              value={isPickupStore ? storeName : pickBusinessName}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
              <Label style={{ marginBottom: 0 }}>Pickup Address</Label>
              <Button color="info" outline size="sm" onClick={() => setIsPinModalOpen(true)} disabled={isPickupStore}>
                Drop Pin
              </Button>
            </div>
            {isPickupAutoFilled ? (
              <Input value={isPickupStore ? storeAddress : pickFullAddress} onChange={e => (isPickupStore ? null : setPickFullAddress(e.target.value))} />
            ) : (
              // <MapboxAutocomplete
              //   id="mapbox-autocomplete"
              //   inputClass={errors.pickupAddress ? 'form-control mb-2' + ' has-danger' : 'form-control mb-2 has-danger'}
              //   publicKey={MAPBOX_TOKEN}
              //   onSuggestionSelect={handlePickupSelect}
              //   country="us"
              //   resetSearch={false}
              //   readOnly={isPickupStore}
              //   defaultValue={isPickupStore ? storeAddress : null}
              //   value={isPickupStore ? storeAddress : pickFullAddress}
              //   query={pickFullAddress}
              //   placeholder="Street Address"
              //   proximityLat={vendorLat}
              //   proximityLng={vendorLong}
              // />
              <GoogleMapAutoComplete
                inputClass={errors.pickupAddress ? 'form-control mb-2 has-danger' : 'form-control mb-2 has-danger'}
                onSuggestionSelect={(...args) => {
                  if (setIsPickupPinnedLocation) {
                    setIsPickupPinnedLocation(false);
                  }
                  handlePickupSelect(...args);
                }}
                country="us"
                resetSearch={false}
                readOnly={isPickupStore}
                defaultValue={isPickupStore ? storeAddress : null}
                value={isPickupStore ? storeAddress : pickFullAddress}
                query={pickFullAddress}
                placeholder="Street Address"
                proximityLat={vendorLat}
                proximityLng={vendorLong}
              />
            )}

            {/* <div hidden={errorMessageDistance.errorCode !== 1}>
              <p style={{ color: 'red', marginTop: '4px' }}>{errorMessageDistance.errorMessage}</p>
            </div> */}
            <div hidden={!errors.pickupAddress}>
              <p style={{ color: 'red', marginTop: '4px' }}>Please choose an address from the dropdown menu</p>
            </div>
            <div hidden={!isPickupStore}>
              <p style={{ color: '#6c757d', marginTop: '4px' }}>Using the selected store address. Choose Different Address to edit this field.</p>
            </div>
            {isPickupPinnedLocation ? (
              <p style={{ color: isCoordinateFallbackLabel(pickFullAddress) ? '#f7941d' : '#6c757d', marginTop: '4px' }}>
                Pinned location selected. Reopen Drop Pin to adjust it.
              </p>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label for="order-pickup">Pickup Instructions (optional)</Label>
            <Input
              type="text"
              name="dropoff"
              id="dropoff-instructions"
              placeholder="Park in back, attendant will assist."
              onChange={e => {
                if (e.target.value.length < 510) {
                  return setPickupInstruction(e.target.value);
                } else {
                  return;
                }
              }}
              value={pickupInstruction}
            />
          </FormGroup>
        </Col>
      </Row>
      <LocationMapPickerModal
        isOpen={isPinModalOpen}
        toggle={() => setIsPinModalOpen(open => !open)}
        title="Select Pickup Location"
        initialLocation={currentLocation}
        onConfirm={location => {
          handlePickupSelect(location);
          if (setIsPickupPinnedLocation) {
            setIsPickupPinnedLocation(true);
          }
          setIsPickupAutoFilled(false);
        }}
      />
    </>
  );
};

export default PickupInfoRouted;
